import { motion } from "framer-motion";
import { ContactCTA } from "@/components/site/ContactCTA";
import { Marquee } from "@/components/site/Marquee";
import { CERTIFICATIONS } from "@/data/products";

const values = [
    { k: "Local", v: "Formulated and packed in Rusayl, Muscat." },
    { k: "Enduring", v: "Built for Oman's coastal salt and desert heat." },
    { k: "Clean", v: "Free of ammonia, lead, mercury and phthalates." },
    { k: "Modern", v: "Advanced binders, superior pigments, refined finish." },
];

export default function AboutPage() {
    return (
        <main className="bg-bone text-ink" data-testid="page-about">
            <section className="pt-32 md:pt-40 pb-16 md:pb-24 border-b border-ink/10">
                <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                    <div className="font-mono text-[10px] uppercase tracking-widest text-ink/50">
                        Home · 04 / The House
                    </div>
                    <motion.h1
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        className="mt-4 font-display text-5xl md:text-8xl lg:text-[9rem] leading-[0.9] tracking-[-0.02em]"
                    >
                        A paint made <br />
                        <span className="italic text-brand-red">for here.</span>
                    </motion.h1>
                </div>
            </section>

            <section className="py-20 md:py-28">
                <div className="mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-12 gap-8">
                    <div className="col-span-12 md:col-span-5">
                        <div className="font-mono text-[10px] uppercase tracking-widest text-ink/50 mb-6">
                            Our story
                        </div>
                        <div className="space-y-6 text-ink/80 text-lg leading-relaxed">
                            <p>
                                Mist Paints is a coatings house rooted in Muscat, born from a simple
                                belief — that the paint on your wall should be as thoughtful as the
                                architecture around it, and as resilient as the climate it lives in.
                            </p>
                            <p>
                                We formulate in Rusayl Industrial Estate using advanced binders and
                                pigments engineered to survive the swing between desert sun and coastal
                                humidity. Every batch is climate-tested. Every finish is chosen for
                                its longevity.
                            </p>
                            <p>
                                Our tortoise is the mark of that philosophy: slow, steady, armoured
                                with colour, and built to outlast trends.
                            </p>
                        </div>
                    </div>

                    <div className="col-span-12 md:col-span-6 md:col-start-7">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            {values.map((v, i) => (
                                <motion.div
                                    key={v.k}
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.7, delay: i * 0.08 }}
                                    className="p-6 md:p-8 border border-ink/15 bg-cream/40"
                                >
                                    <div className="font-mono text-[10px] uppercase tracking-widest text-brand-red">
                                        0{i + 1}
                                    </div>
                                    <div className="mt-4 font-display text-3xl">{v.k}.</div>
                                    <div className="mt-3 text-ink/70">{v.v}</div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-10 md:py-14 border-y border-ink/10 overflow-hidden">
                <Marquee items={CERTIFICATIONS} />
            </section>

            <ContactCTA />
        </main>
    );
}
